
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class ToastService {

    constructor(
        private toastController: ToastController
    ) { }

    public showToast(message: string, duration: number = 1500) {
        this.toastController.create({
            message, duration, position: 'bottom'
        }).then(toast => {
            toast.present();
        });
    }
}